import { render, staticRenderFns } from "./AdminNewClient.vue?vue&type=template&id=78856d98&scoped=true"
import script from "./AdminNewClient.vue?vue&type=script&lang=js"
export * from "./AdminNewClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78856d98",
  null
  
)

export default component.exports